import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';


export const TechnicalDocumentation = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Technical Document', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Technical Document" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
<section class="service-details section-space">
  <div class="container">
    <div class="row flex-xl-row flex-column-reverse">
      <div class="col-xl-4">
        <div class="sidebar sidebar-rr-sticky">
          <div class="sidebar__widget-service mb-30">
            <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i> </Link>
            <Link to="/pharmaceutical-details">Pharmaceutical & Biotech Industry <i class="fa-solid fa-plus"></i> </Link>
            <Link to="/healthcare-details">Healthcare Providers <i class="fa-solid fa-plus"></i> </Link>
          </div>

          <div class="sidebar__widget-contact__service text-center">
            <h4 class="mb-25 title-animation text-capitalize">Are You Ready to Contact Us?</h4>
            <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i>(+86) 19811976744</a></p>
            <Link to="/contact-us#" class="rr-btn">
              <span class="btn-wrap">
                <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="service-details__content">
          <div class="service-details__content-media mb-20">
            <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="Technical Documentation" />
          </div>

          <h2 class="title-animation mb-20">Technical Documentation</h2>
          <p class="mb-20">Technical documentation is a comprehensive set of documents required for every medical device. It is vital to meet regulatory requirements established by MDR (EU), FDA (US), and NMPA (China). This documentation provides detailed information on device design, risk management, manufacturing processes, and clinical evaluations, ensuring that medical devices are safe, effective, and meet international standards. It also plays a key role in securing market approvals and maintaining ongoing compliance across these regulatory regions.</p>

          <h3 class="title-animation mb-10">Types of Technical Documentation for the Medical Device Industry</h3>
          <ul class="mb-40">
            <li><span><i class="fa-solid fa-check"></i></span>Device Description and Specifications</li>
            <li><span><i class="fa-solid fa-check"></i></span>Design and Development Files</li>
            <li><span><i class="fa-solid fa-check"></i></span>Risk Management Documentation</li>
            <li><span><i class="fa-solid fa-check"></i></span>Manufacturing Process Documentation</li>
            <li><span><i class="fa-solid fa-check"></i></span>Quality Management System (QMS) Documentation</li>
            <li><span><i class="fa-solid fa-check"></i></span>Performance and Safety Test Reports</li>
            <li><span><i class="fa-solid fa-check"></i></span>Clinical Evaluation</li>
            <li><span><i class="fa-solid fa-check"></i></span>Clinical Investigations</li>
            <li><span><i class="fa-solid fa-check"></i></span>Labeling and Instructions for Use (IFU)</li>
            <li><span><i class="fa-solid fa-check"></i></span>Regulatory Compliance Certificates</li>
            <li><span><i class="fa-solid fa-check"></i></span>Post-Market Surveillance Plan</li>
            <li><span><i class="fa-solid fa-check"></i></span>Change Control and Document History Records</li>
            <li><span><i class="fa-solid fa-check"></i></span>Sterilization and Biocompatibility Reports</li>
            <li><span><i class="fa-solid fa-check"></i></span>Software Documentation (if applicable)</li>
            <li><span><i class="fa-solid fa-check"></i></span>Usability</li>
            <li><span><i class="fa-solid fa-check"></i></span>Medical Electric Safety</li>
            <li><span><i class="fa-solid fa-check"></i></span>Validation and Verification Reports</li>
          </ul>

          <h3 class="title-animation mb-10">SQUARE MEDTECH Expertise in Technical Documentation</h3>
          <p class="mb-30">All medical devices require comprehensive documentation to demonstrate regulatory compliance. SQUARE MEDTECH supports you in planning, creating, and maintaining the necessary technical documentation to meet global standards.</p>

          <h3 class="title-animation mb-10">How SQUARE MEDTECH Can Help with Technical Documentation</h3>
          <ul class="mb-40">
            <li>
              <span><i class="fa-solid fa-check"></i></span>
              <h5>Conducting a GAP Analysis of Existing Technical Documentation</h5>
            </li>
            <li>
              <span><i class="fa-solid fa-check"></i></span>
              <h5>Assisting in Planning the Required Documentation for New Products or Projects</h5>
            </li>
            <li>
              <span><i class="fa-solid fa-check"></i></span>
              <h5>Supporting the Creation of All Necessary Technical Documentation Elements</h5>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
       
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Service for Technical Documentations:</h4>
                      <ul class="color-white mb-0">
                        <li>Clinical Evaluation</li>
                        <li>Clinical Investigation</li>
                        <li>Regulatory Life Cycle</li>
                      </ul>

                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Service for Technical Documentations:</h4>
                      <ul class="color-white mb-0">
                        <li>PMCF Solution</li>
                        <li>Healthcare Survey</li>
                        <li>EU MDR/FDA/NMPA Consulting</li>
                      </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
